import { WORKSPACE_FRAME_PADDING, WORKSPACE_PADDING } from '@components/v2/constants';
import AppTemplate from '@components/v2/layout/AppTemplate/AppTemplate';
import { Box } from '@mui/material';
import { type ReactNode } from 'react';
import PublicLoginButton from '../../modules/login/components/PublicLoginButton';
import ProductDetailsPanel from '../../modules/products/products-details-v2/components/ProductDetailsPanel/ProductDetailsPanel';
import ProductDetailsUrlSync from '../../modules/products/products-details-v2/components/ProductDetailsUrlSync/ProductDetailsUrlSync';
import PublicNavigationHeader from './components/PublicNavigationHeader/PublicNavigationHeader';
import { usePublicNavigation } from './hooks/usePublicNavigation';

const FLOAT_INSET = WORKSPACE_FRAME_PADDING + WORKSPACE_PADDING;

interface PublicNavigationProps {
  children?: ReactNode;
}

const PublicNavigation = ({ children }: PublicNavigationProps) => {
  const { sharedEntity, isProductDetailsEnabled, isLoginButtonVisible } = usePublicNavigation();

  if (!sharedEntity) {
    return <>{children}</>;
  }

  const loginButton = isLoginButtonVisible ? (
    <Box
      sx={(theme) => ({
        position: 'absolute',
        right: theme.spacing(FLOAT_INSET),
        bottom: theme.spacing(FLOAT_INSET),
        zIndex: theme.zIndex.fab,
      })}
    >
      <PublicLoginButton brandSlug={sharedEntity.config.slug} />
    </Box>
  ) : null;

  return (
    <>
      {isProductDetailsEnabled && <ProductDetailsUrlSync />}

      <AppTemplate
        navItems={[]}
        collapsedMode="hidden"
        slots={{
          header: <PublicNavigationHeader />,
          workspaceOverlay: (
            <>
              {isProductDetailsEnabled && <ProductDetailsPanel />}
              {loginButton}
            </>
          ),
        }}
      >
        {children}
      </AppTemplate>
    </>
  );
};

export default PublicNavigation;
